import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-black';
  const variants = {
    primary: 'bg-amber-500 text-black hover:bg-amber-400',
    secondary: 'bg-zinc-800 text-white hover:bg-zinc-700',
    outline: 'border-2 border-amber-500 text-amber-500 hover:bg-amber-500/10'
  };
  const sizes = {
    sm: 'px-3.5 py-1.5 text-xs sm:px-5 sm:py-2.5 sm:text-sm',
    md: 'px-4 py-2.5 text-sm sm:px-7 sm:py-3.5 sm:text-base',
    lg: 'px-5 py-3 text-sm sm:px-9 sm:py-5 sm:text-lg'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthStyle} ${className}`} {...props} data-id="element-1">
      {children}
    </button>;
}